<div *ngIf="auth.authenticated && auth?.user?.agentDNCEntriesAccess;else other_content;">
    <h2>Agent DNC Entries</h2>
    <br />
    <p *ngIf="!allApplications"><em>Loading...</em></p>
  
    <div *ngIf="allApplications" class="applications">
      <table class='table'>
        <thead>
          <tr>
            <th style="text-align: center">Index</th>
            <th style="text-align: center">Phone Number</th>
            <th style="text-align: center">Account Number</th>
            <th style="text-align: center">Third Party Type</th>
            <th style="text-align: center">Submitted By</th>
            <th style="text-align: center">Date Time Received</th>
            <th style="text-align: center;">Done?</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let application of allApplications; let isOdd=odd; let i=index;">
            <tr [class.odd]="isOdd">
              <td style="text-align: center">
                <span>{{ i + 1 }}</span>
              </td>
              <td style="text-align: center">
                {{ application.phoneNumber }}
              </td>
              <td style="text-align: center">
                {{ application.accountNumber }}
              </td>
              <td style="text-align: center">
                {{ application.thirdPartyType }}
              </td>
              <td style="text-align: center">
                {{ application.agentEmailAddress }}
              </td>
              <td style="text-align: center">
                {{ application.insertDateTime | date: 'MM/dd/yyyy hh:mm a'}}  
              </td>
              <td style="text-align: center">
                <button type="button"  class="btn btn-success" id="Complete" (click)='complete(application)'>Done</button>        
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  
  <ng-template #other_content>
    <div *ngIf="!auth.authenticated; else unauthorized;">
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
  
      <div class="numbers">
        <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
      </div>
  
      <br />
      <br />
      <br />
      <br />
  
      <div class="numbers">
        <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
      </div>
  
    </div>
    <ng-template #unauthorized>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
    </ng-template>
  </ng-template>



// WEBPACK FOOTER //
// ./src/app/agent-dnc-entries/agent-dnc-entries.component.html